import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

interface IParams {
  isStandingInitialized: boolean,
  search: Record<string, unknown>,
  initialFiltersSnapshot: Record<string, unknown>,
  setInitialFiltersSnapshot: (v: Record<string, unknown>) => void,
  initProductRegionFilters: (shouldSetFilterFromHeader?: boolean) => boolean,
  onProductRegionChange: () => void,
}

export const useSyncProductRegionFilters = ({
  isStandingInitialized,
  search,
  initialFiltersSnapshot,
  setInitialFiltersSnapshot,
  initProductRegionFilters,
  onProductRegionChange,
}: IParams) => {
  useEffect(() => {
    if (isStandingInitialized) {
      const filtersChanged = initProductRegionFilters(true);
      if (filtersChanged) onProductRegionChange();
    } else if (!isEmpty(search) && isEmpty(initialFiltersSnapshot)) {
      setInitialFiltersSnapshot(search);
    }
  }, [search]);
};
